
import React from 'react';
import { Collapsible, CollapsibleTrigger, CollapsibleContent } from '@/components/ui/collapsible';
import { ChevronDown, ChevronUp } from 'lucide-react';
import { cn } from '@/lib/utils';

interface NumberedCollapsibleSectionProps {
  number: number;
  title: string;
  open: boolean;
  onOpenChange: (open: boolean) => void;
  isCompleted: boolean;
  isDisabled: boolean;
  children: React.ReactNode;
}

const NumberedCollapsibleSection: React.FC<NumberedCollapsibleSectionProps> = ({
  number,
  title,
  open,
  onOpenChange,
  isCompleted,
  isDisabled,
  children
}) => {
  return (
    <Collapsible 
      open={open} 
      onOpenChange={onOpenChange}
      disabled={isDisabled}
      className={cn(
        "rounded-md border",
        isDisabled ? "opacity-70" : "",
        isCompleted ? "border-green-100" : "border-gray-200"
      )}
    >
      <CollapsibleTrigger className="flex w-full items-center justify-between p-4 text-left">
        <div className="flex items-center">
          <div className={cn(
            "flex h-7 w-7 items-center justify-center rounded-full border mr-3",
            isCompleted ? "border-green-200 bg-green-50" : "border-gray-200 bg-gray-50"
          )}>
            <span className={cn(
              "text-sm font-medium",
              isCompleted ? "text-green-600" : "text-gray-600"
            )}>
              {number}
            </span>
          </div>
          <span className={cn(
            "text-lg font-medium",
            isCompleted ? "text-green-600" : ""
          )}>
            {title}
          </span>
        </div>
        
        <div className="flex items-center">
          {open ? <ChevronUp className="h-5 w-5" /> : <ChevronDown className="h-5 w-5" />}
        </div>
      </CollapsibleTrigger>
      
      <CollapsibleContent className="px-6 pb-6 pt-2">
        {children}
      </CollapsibleContent>
    </Collapsible>
  );
};

export default NumberedCollapsibleSection;
